import { Column, Typography } from '@tempmee/react';
import { TextAreaField } from '~/components/shared/forms';

export const NotesForProfessional = ({ value, onChange }) => (
  <Column gap={2} py={5}>
    <Typography as="h2" variant="body1" weight="bold">
      Notes for Dental Professional:
    </Typography>
    <TextAreaField
      placeholder="Check in at front desk"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      height={80}
    />
  </Column>
);
